<span [class]="'loader size-' + size()"></span>
@if (label()) {
  <span class="spinner-label" dir="auto">{{ label() }}</span>
}
